import { useStripeTeamSubscription } from '@/modules/growthmentor/team/composables/useStripeTeamSubscription.ts'
import { useTeamCoupon } from '@/modules/growthmentor/team/composables/useTeamCoupon.ts'
import { useForm } from '@inertiajs/vue3'
import { useCurrentUser } from '@/shared/composables/useCurrentUser'
import { computed } from 'vue'
import { usePermissionSystem } from '@/shared/composables/usePermissionSystem.js'
import {
  SUBSCRIPTION_STATUS,
  TEAM_ROLE,
} from '@/shared/data/permissionSystem.js'
import { TEAM_SEATS_OPTIONS_VALUES } from '@/shared/data/teamSeatsOptions.ts'

export const useCreateTeam = () => {
  const { currentUser } = useCurrentUser()
  const { isSubscriptionStatus, hasTeamRole } = usePermissionSystem()

  const form = useForm({
    seats: TEAM_SEATS_OPTIONS_VALUES[0],
  })

  const {
    startSubscription,
    errors: stripeErrors,
    isLoading: isStripeLoading,
  } = useStripeTeamSubscription()
  const { couponCode: teamCouponCode } = useTeamCoupon()

  const createTeam = (teamPlanId: string, couponCode: string | null) => {
    // Coupon code can be either passed as an argument meaning user has entered it manually
    // or it can be taken from the team's data if user has already created a team
    const couponCodeToUse = couponCode || teamCouponCode.value

    // Has team created but not paid
    if (
      isSubscriptionStatus(SUBSCRIPTION_STATUS.NOT_PAID) &&
      hasTeamRole(TEAM_ROLE.OWNER)
    ) {
      startSubscription({
        planId: teamPlanId,
        seats: form.seats,
        couponCode: couponCodeToUse,
      }).then(() => {})
      // Team is not created and not paid
    } else {
      form
        .transform((data) => ({
          team: {
            name: `${currentUser.value.firstName}'s Team`,
            seats: data.seats,
          },
        }))
        .post('/team', {
          preserveScroll: true,
          onSuccess: () => {
            startSubscription({
              planId: teamPlanId,
              seats: form.seats,
              couponCode: couponCodeToUse,
            }).then(() => {})
          },
        })
    }
  }

  return {
    createTeam,
    stripeErrors,
    form,
    isLoading: computed(() => form.processing || isStripeLoading.value),
  }
}
